import { create } from 'zustand';
import { BASELINE_DURATION } from '@types';

interface BaselineCalculationState {
  isBaselineCalculating: boolean;
  baselineTimer: number;
  baselineDefaultDuration: number;
  baseline: number;
  setIsBaselineCalculating: (value: boolean) => void;
  setBaselineTimer: (value: number) => void;
  setBaselineDefaultDuration: (value: number) => void;
  setBaseline: (value: number) => void;
}

export const useBaselineCalculationStore = create<BaselineCalculationState>(
  set => ({
    isBaselineCalculating: false,
    baselineTimer: 0,
    baselineDefaultDuration: BASELINE_DURATION,
    baseline: 0,
    setIsBaselineCalculating: value => set({ isBaselineCalculating: value }),
    setBaselineTimer: value => set({ baselineTimer: value }),
    setBaselineDefaultDuration: value =>
      set({ baselineDefaultDuration: value }),
    setBaseline: value => set({ baseline: value }),
  })
);
